import frappe, { mapPaymentMode, COMPANY } from './frappe';
import { getInvoiceById } from './getInvoices';

export async function agregarInvoice(invoiceData) {
  try {
    const today = new Date().toISOString().split('T')[0];
    const payload = {
      customer: invoiceData.socid || invoiceData.customer,
      posting_date: today,
      due_date: today,
      company: COMPANY,
      items: (invoiceData.lines || []).map(line => ({
        item_code: line.fk_product,
        qty: line.qty,
        rate: line.subprice,
      })),
      mode_of_payment: mapPaymentMode(invoiceData.mode_reglement_id),
      docstatus: 0,
    };

    const { data } = await frappe.post('/api/resource/Sales%20Invoice', payload);
    return data.data;
  } catch (error) {
    console.error('Error en la creación del Invoice:', error.response?.data || error.message);
    throw error;
  }
}

export async function validateInvoice(invoiceId) {
  try {
    const { data } = await frappe.post('/api/method/frappe.client.submit', {
      doc: { doctype: 'Sales Invoice', name: invoiceId },
    });
    return data.message;
  } catch (error) {
    console.error('Error al validar Invoice:', error.response?.data || error.message);
    throw error;
  }
}

// Crea una Sales Invoice a partir de una Sales Order existente
export const createInvoiceFromOrder = async (orderId) => {
  try {
    // ERPNext provee un método para generar el invoice desde la orden
    const { data } = await frappe.post(
      '/api/method/erpnext.selling.doctype.sales_order.sales_order.make_sales_invoice',
      { source_name: orderId }
    );

    const invoiceDoc = data.message;
    const { data: saved } = await frappe.post('/api/resource/Sales%20Invoice', invoiceDoc);

    return saved.data;
  } catch (error) {
    console.error('Error al crear factura desde orden:', error.response?.data || error.message);
    return null;
  }
};

// Actualiza el método de pago en el invoice (antes de validarlo)
export const invoiceBanKAccountUpdate = async (invoiceId, newModeReglementId) => {
  try {
    const modeOfPayment = mapPaymentMode(parseInt(newModeReglementId, 10));
    const { data } = await frappe.put(`/api/resource/Sales%20Invoice/${invoiceId}`, {
      mode_of_payment: modeOfPayment,
    });
    return data.data;
  } catch (error) {
    console.error('Error al actualizar método de pago del invoice:', error.message);
    return null;
  }
};

// Registra el pago de un invoice creando un Payment Entry
export const addPaymentToInvoice = async (invoiceId) => {
  try {
    const invoice = await getInvoiceById(invoiceId);
    if (!invoice) throw new Error('No se pudo obtener la factura');

    const { data } = await frappe.post('/api/resource/Payment%20Entry', {
      payment_type: 'Receive',
      mode_of_payment: invoice.mode_of_payment || 'Cash',
      party_type: 'Customer',
      party: invoice.customer,
      party_name: invoice.customer_name,
      paid_amount: invoice.outstanding_amount,
      received_amount: invoice.outstanding_amount,
      company: COMPANY,
      references: [
        {
          reference_doctype: 'Sales Invoice',
          reference_name: invoiceId,
          allocated_amount: invoice.outstanding_amount,
          total_amount: invoice.grand_total,
          outstanding_amount: invoice.outstanding_amount,
        },
      ],
    });

    return data.data.name;
  } catch (error) {
    console.error('Error al agregar pago a la factura:', error.message);
    return null;
  }
};

// No se usa directamente — mantenida por compatibilidad con el flujo existente
export async function payInvoice(invoiceId, paymentid) {
  return addPaymentToInvoice(invoiceId);
}
